<template>
  <div class="col">
    <label for="selectIsMonth" class="form-label"></label>
    <div class="row row-cols-auto">
      <label class="col form-label mx-0 px-3">일간</label>
      <div class="col form-check form-switch mx-0">
        <input class="form-check-input"
               type="checkbox"
               role="switch"
               id="monthCheck"
               :checked="props.isActive"
               @change="handleChange">
      </div>
      <label class="col mx-0 px-0 form-label">월간</label>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted} from "vue";
import {useStore} from "vuex";
import {searchBarProps} from "@/store";

const store = useStore();
const patchSearchBar = (data) => store.dispatch('patchSearchBar', data);
const emit = defineEmits(['change']);
const props = defineProps({
  isActive: Boolean,
});

async function handleChange(evt) {
  await patchSearchBar({
    prop: searchBarProps.selectByMonth,
    value: evt.target.checked,
  });
}

onMounted(() => {

});

</script>

<style scoped>
</style>
